import styled from 'styled-components'

import { color, font } from '~/styles/utils'

export const AddressElement = styled.span<{ $highlighted?: boolean }>`
  color: ${(props) => props.$highlighted && color('red')};
  ${(props) => props.$highlighted && font('demi')};
`
